import axios from 'axios';
import { ACCESS_TOKEN } from './token';
import UserProfile from '../components/User';
import { config } from '../config';

const apiUrl = config.url.API_ENDPOINT;

// console.log(import.meta);

// const baseURL = import.meta.env.REACT_APP_API_ENDPOINT ? import.meta.env.REACT_APP_API_ENDPOINT : apiUrl;
const baseURL = apiUrl;

const api = axios.create({
    baseURL: baseURL
})

const isDev = process.env.NODE_ENV === 'development';

api.interceptors.request.use(
    (config) => {
        const accessToken = window.sessionStorage.getItem(ACCESS_TOKEN);
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        if (isDev) {
            console.log('Starting Request', config);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => {
        if (isDev) {
            console.log('Response:', response);
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            UserProfile.logout();
        }
        return Promise.reject(error);
    }
);

export default api;